// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RefundPolicy_refund-img__RlY0O{
    width: 85vw;
    height: 40vw;
    object-fit: cover;
    border-radius: 1vw;
}

@media(max-width: 768px){
    .RefundPolicy_refund-img__RlY0O{
        border: 1px solid black;
        border-radius: 5vw;
        width: 90vw;
        height: 50vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/Tabs/RefundPolicy/RefundPolicy.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,uBAAuB;QACvB,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".refund-img{\n    width: 85vw;\n    height: 40vw;\n    object-fit: cover;\n    border-radius: 1vw;\n}\n\n@media(max-width: 768px){\n    .refund-img{\n        border: 1px solid black;\n        border-radius: 5vw;\n        width: 90vw;\n        height: 50vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"refund-img": `RefundPolicy_refund-img__RlY0O`
};
export default ___CSS_LOADER_EXPORT___;
